//    Copyright 2020 Siemens
import {default as SPLM} from "../no/splm.js";
import "../no/CAM.js";
import "../CAM/CAM.ParamBuilder.js";
import "../CAM/CAM.InheritableToolDepBuilder.js";
import "../CAM/CAM.ToolPathTiltAvoidance.js";
import "../CAM/CAM.ToolPathTiltClearance.js";
import "../CAM/CAM.ToolPathTiltMachine.js";
import "../CAM/CAM.ToolPathTiltTilting.js";
let d=[[[1,"FanDistance",0,"CAM.InheritableToolDepBuilder",1],[0,"MaintainTilt",1,1],[1,"MaxMaintainTiltDistance",0,"CAM.InheritableToolDepBuilder",1],[0,"MaxTiltAngle",1,1],[1,"MinHolderClearance",0,"CAM.InheritableToolDepBuilder",1],[1,"MinNeckClearance",0,"CAM.InheritableToolDepBuilder",1],[1,"MinSafeClearance",0,"CAM.InheritableToolDepBuilder",1],[1,"MinShankClearance",0,"CAM.InheritableToolDepBuilder",1],[0,"PreferredTiltAngle",1,1],[1,"TiltAvoidance",0,"CAM.ToolPathTiltAvoidance",0],[1,"TiltClearance",0,"CAM.ToolPathTiltClearance",0],[1,"TiltMachine",0,"CAM.ToolPathTiltMachine",0],[1,"TiltTilting",0,"CAM.ToolPathTiltTilting",0],[0,"ToolAxisChange",1,1]],[],[]];
SPLM.CAM.ToolPathTiltBuilder = class extends SPLM.CAM.ParamBuilder{
    constructor (creator){
        super(creator);
        this._d['Class'] = "SPLM.CAM.ToolPathTiltBuilder";
        SPLM.c$d(this.Class,d);d=[];
    }
};

export default SPLM;